export default "__VITE_ASSET__aI$xO1fq__"